import React from 'react'
import { useTranslation } from 'react-i18next'
import { EmptyState } from '@node-space/ui-components'
import { Lottie } from 'components/Animations/SimpleLottie'

export const NetworkMembersEmptyState = () => {
  const { t } = useTranslation()

  return (
    <EmptyState
      testId="empty-state"
      LottiePlayer={<Lottie src="no-data" />}
      title={t('bvnkNetwork.noNetworkMembersHeadline')}
      description={t('bvnkNetwork.noNetworkMembersDescription')}
    />
  )
}
